module.exports = __webpack_public_path__ + "img/bb1489f.png";